// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__XhTq8","open":"modal_open__85i8l","modalContent":"modal_modalContent__kny9r","closeButton":"modal_closeButton__2JxWG"};